import {
  Paper,
  Table,
  Button,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  FormGroup,
  Typography,
  TableRow,
  TableHead,
  TableCell,
  LinearProgress,
  FormControlLabel,
  Checkbox,
  Switch
} from "@material-ui/core";
import GetRole from "./user";
import RezliveBook from "./rezlivebook";
import { Dialog } from "@mui/material";
import Stack from '@mui/material/Stack';
import { makeStyles } from "@material-ui/core/styles";
import { fetchDest, rzsearchhotelbydest, rzhoteldetails, fetchdestHotelsbyDestandCity, rzsearchhotelbyid, fetchCurrencyData} from "../api/customerapi";
import { useState, useEffect } from "react";
import { childagearray, destcode, citycode, formatDate3, getratingdata, getnationality } from "./date.js";
import { XMLParser } from "fast-xml-parser";
import { v4 as uuidv4 } from "uuid";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(4),
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
  },
  formgroup: {
    justifyContent: "center",
  },

  headertext: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(3),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: theme.spacing(14),
    height: theme.spacing(5),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    fontSize: 10,
    verticalAlign: "middle",
  },
  button2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: theme.spacing(10),
    height: theme.spacing(3),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    fontSize: 10,
    verticalAlign: "middle",
  },
  button3: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: theme.spacing(20),
    height: theme.spacing(3),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    fontSize: 10,
    verticalAlign: "middle",
  },
  
  textField: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    width: theme.spacing(20),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textAlign: "left",
  },
}));

const RezliveSearch = () => {
  const width = window.innerWidth - 100;
  const classes = useStyles();
  const [searchData, setsearchData] = useState({});
  const [responseData, setresponseData] = useState([{}]);
  const [hdData, sethdData] = useState([{}]);
  const [dest, setdest] = useState([]);
  const [ssid, setssid] = useState("");
  const [Open4, setOpen4] = useState(false);
  const [onlybf, setonlybf] = useState(false);
  const [roomdetails, setroomdetails] = useState([]);
  const [listhotelData, setlisthotelData] = useState([]);
  const [hoteldetails, sethoteldetails] = useState([]);
  const [showbook, setshowbook] = useState(false);
  const [searchbyid, setsearchbyid] = useState(false);
  const [roomdata, setroomdata] = useState([]);
  const [hotelData, sethotelData] = useState([]);
  const [status, setstatus] = useState("Normal");
  const [filterData, setfilterData] = useState({rating:0,text:""});
  const [showid, setshowid] = useState([]);
  const [cities, setcities] = useState([]);
  const [curr, setcurr] = useState([]);
  const [showtnc, setshowtnc] = useState(false);
  const [tnc, settnc] = useState("");
  var { cuser, role } = GetRole();

  const destlist=["India","Canada","Greece","Slovenia","Saint Lucia","United States","Czech Republic","Germany","United Kingdom","Albania","Andorra","Denmark","Antigua And Barbuda","Argentina","Austria","Armenia","Aruba","Australia","Dominican Republic","Ecuador","Egypt","Cameroon","El Salvador","Estonia","Fiji","Finland","Azerbaijan","Bahamas","Bahrain","Barbados","Belarus","Belgium","Bolivia","France","Brazil","Bulgaria","Cambodia","Cayman Islands","New Zealand","Chile","China","Indonesia","Colombia","Costa Rica","Croatia","Cyprus","Georgia","Gibraltar","Grenada","Guadeloupe","Guatemala","Honduras","Hong Kong","Hungary","Iceland","Ireland","Israel","Italy","Jamaica","Japan","Jordan","South Korea","Kuwait","Latvia","Liechtenstein","Lithuania","Luxembourg","Macedonia","Malaysia","Malta","Mexico","Moldova","Monaco","Morocco","Mozambique","Netherlands","Norway","Netherlands Antilles","Nicaragua","Oman","Panama","Paraguay","Peru","Philippines","Poland","Portugal","Puerto Rico","Qatar","Romania","Russia","San Marino","Serbia","Singapore","Slovakia","South Africa","Spain","Sri Lanka","Sweden","Switzerland","Tanzania","Taiwan","Thailand","Tunisia","Turkey","Turks And Caicos Islands","Ukraine","United Arab Emirates","Uruguay","US Virgin Islands","Uzbekistan","Vanuatu","Venezuela","Vietnam","Bosnia And Herzegovina","Brunei Darussalam","Laos","Nepal","Ghana","Saudi Arabia","Trinidad And Tobago","Yemen","Djibouti","Macau","Benin","Swaziland","Cuba","Myanmar","Martinique","Maldives","Namibia","Suriname","Anguilla","Saint Kitts And Nevis","Montenegro","Belize","Eritrea","Kazakhstan","Kenya","Lebanon","Pakistan","Papua New Guinea","French Polynesia","Zambia","Algeria","Zimbabwe","Bermuda","Botswana","Burkina Faso","Uganda","Cape Verde","Syrian Arab Republic","New Caledonia","Palau","Reunion","Mauritius","Mali","Malawi","Madagascar","Libyan Arab Jamahiriya","Iran","Gambia","Saint Martin","Senegal","Seychelles","Angola","British Virgin Islands","Saint Vincent And The Grenadines","Equatorial Guinea","Gabon","Bangladesh","Ethiopia","Guam","Nigeria","Dominica","Faroe Islands","Rwanda","Burundi","Cook Islands","Kyrgyzstan","Tajikistan","Greenland","Haiti","Iraq","Liberia","Palestinian Territory","Micronesia","Sudan","Northern Mariana Islands","Sao Tome And Principe","Saint Barthelemy","Mauritania","Guinea","Guinea-Bissau","French Guiana","Samoa","Tonga","Afghanistan","Guyana","American Samoa","Bhutan","Lesotho","Mongolia","Norfolk Island","Svalbard And Jan Mayen","Togo","Turkmenistan","Comoros","Jersey","Kiribati","Ivory Coast","Marshall Islands","Solomon Islands","Democratic Republic of the Congo","Central African Republic","Chad","Republic of the Congo","Mayotte","Montserrat","Nauru","Niger","Sierra Leone","Somalia","Tuvalu","Niue","Bouvet Island","British Indian Ocean Territory","Christmas Island","Cocos Islands","Falkland Islands","French Southern and Antarctic Territories","Heard and McDonald Islands","North Korea","Pitcairn Island","St. Pierre and Miquelon","St. Helena","Tokelau","Wallis and Futuna","Timor Leste","Bonaire","Curacao","Sint Maarten","South Sudan","US Minor Outlying Islands","Vatican City"]

  const handleSubmit = async (e) => {
    e.preventDefault();
    setstatus("searching");
    //var nation=getnationality(searchData.nationality)
    var nation="IN"
    if(searchbyid){
      searchData.rooms=roomdata
      if (searchData.citycode && searchData.destcode && searchData.start_date && searchData.end_date && searchData.hotel && "rooms" in searchData && searchData.rooms.length>0) {
        var nation=getnationality(searchData.nationality)
        var room=""
        
        for (let i=0; i<searchData.rooms.length; i++) {
          var cdata=""
          
          if("number_child" in searchData.rooms[i] && searchData.rooms[i].number_child>0){
            var cage=""
            
            for(let j=0;j<searchData.rooms[i].childnumber.length;j++){
              cage=cage+"<ChildAge>"+searchData.rooms[i].childnumber[j]+"</ChildAge>\n"
            }
            cdata="<NoOfChilds>"+searchData.rooms[i].number_child+"</NoOfChilds>\n"+"<ChildrenAges>\n"+cage+"</ChildrenAges>\n"
          }else{
            cdata="<NoOfChilds>0</NoOfChilds>\n"
          }
          room=room+"<Room>\n"+"<Type>Room-"+(i+1)+"</Type>\n"+"<NoOfAdults>"+searchData.rooms[i].number_adults+"</NoOfAdults>\n"+cdata+"</Room>\n"
        }
  
        var sd=formatDate3(searchData.start_date)
        var ed=formatDate3(searchData.end_date)
        //console.log(searchData)
        var ratingdata=getratingdata(searchData.rating)
        var hotelid=listhotelData.filter(h=>h.hotel_name==searchData.hotel)
        //console.log(hotelid[0].rezlive_id)
        if(hotelid.length>0 && hotelid[0].rezlive_id){
          // var data = {
          //   'XML': '<?xml version="1.0" encoding="UTF-8"?>\n<HotelFindRequest>\n   <Authentication>\n      <AgentCode>CD102014</AgentCode>\n      <UserName>JVXML</UserName>\n      <Password>Operations@2024</Password>\n   </Authentication>\n   <Booking>\n      <ArrivalDate>'+sd+'</ArrivalDate>\n      <DepartureDate>'+ed+'</DepartureDate>\n      <CountryCode>'+searchData.destcode+'</CountryCode>\n      <City>'+hotelid[0].rezlive_city_id+'</City>\n <HotelIDs>\n<Int>'+hotelid[0].rezlive_id+'</Int>\n</HotelIDs>\n     <GuestNationality>'+nation+'</GuestNationality>\n      <Rooms>\n'+room+'</Rooms>\n   </Booking>\n</HotelFindRequest>'
          // };
          var data = {
            'XML': '<?xml version="1.0" encoding="UTF-8"?>\n<HotelFindRequest>\n   <Authentication>\n      <AgentCode>CD112554</AgentCode>\n      <UserName>JETO</UserName>\n      <Password>Operations@2023</Password>\n   </Authentication>\n   <Booking>\n      <ArrivalDate>'+sd+'</ArrivalDate>\n      <DepartureDate>'+ed+'</DepartureDate>\n      <CountryCode>'+searchData.destcode+'</CountryCode>\n      <City>'+hotelid[0].rezlive_city_id+'</City>\n <HotelIDs>\n<Int>'+hotelid[0].rezlive_id+'</Int>\n</HotelIDs>\n     <GuestNationality>'+nation+'</GuestNationality>\n      <Rooms>\n'+room+'</Rooms>\n   </Booking>\n</HotelFindRequest>'
          };
          // var data = {
          //   'XML': '<?xml version="1.0" encoding="UTF-8"?>\n<HotelFindRequest>\n   <Authentication>\n      <AgentCode>CD32468</AgentCode>\n      <UserName>RezliveJetoTest</UserName>\n      <Password>JetoRez@123</Password>\n   </Authentication>\n   <Booking>\n      <ArrivalDate>'+sd+'</ArrivalDate>\n      <DepartureDate>'+ed+'</DepartureDate>\n      <CountryCode>'+searchData.destcode+'</CountryCode>\n      <City>'+searchData.citycode+'</City>\n <HotelIDs>\n<Int>'+hotelid[0].rezlive_id+'</Int>\n</HotelIDs>\n     <GuestNationality>'+nation+'</GuestNationality>\n      <Rooms>\n'+room+'</Rooms>\n   </Booking>\n</HotelFindRequest>'
          // };
         //console.log(data)
          const resdata=await rzsearchhotelbyid(data)
          setstatus("completed")
          //console.log((resdata.data))
          const parser = new XMLParser();
         const jObj = parser.parse(resdata.data);
         setresponseData(jObj.HotelFindResponse)
         console.log(jObj.HotelFindResponse)
         if("error" in jObj.HotelFindResponse && jObj.HotelFindResponse.error.includes("E-1004")){
          setstatus("error")
        }
        if(resdata.data.includes("SearchSessionId")){
          var p1=resdata.data.split("<SearchSessionId>")
          var p2=p1[1].split("</SearchSessionId>")
          setssid(p2[0])
        }
         
        if("Hotels" in jObj.HotelFindResponse && "Hotel" in jObj.HotelFindResponse.Hotels){
                sethotelData([jObj.HotelFindResponse.Hotels.Hotel])
               }

        }else{
          alert("Hotel not mapped with Rezlive")
        }
      } else {
      alert("Error:Did not find all parameters");
      setstatus("completed")
      }
    }else{
      searchData.rooms=roomdata
      if (searchData.citycode && searchData.destcode && searchData.start_date && searchData.end_date && searchData.rating && "rooms" in searchData && searchData.rooms.length>0) {
        var nation=getnationality(searchData.nationality)
        var room=""
        
        for (let i=0; i<searchData.rooms.length; i++) {
          var cdata=""
          
          if("number_child" in searchData.rooms[i] && searchData.rooms[i].number_child>0){
            var cage=""
            
            for(let j=0;j<searchData.rooms[i].childnumber.length;j++){
              cage=cage+"<ChildAge>"+searchData.rooms[i].childnumber[j]+"</ChildAge>\n"
            }
            cdata="<NoOfChilds>"+searchData.rooms[i].number_child+"</NoOfChilds>\n"+"<ChildrenAges>\n"+cage+"</ChildrenAges>\n"
          }else{
            cdata="<NoOfChilds>0</NoOfChilds>\n"
          }
          room=room+"<Room>\n"+"<Type>Room-"+(i+1)+"</Type>\n"+"<NoOfAdults>"+searchData.rooms[i].number_adults+"</NoOfAdults>\n"+cdata+"</Room>\n"
        }
  
        var sd=formatDate3(searchData.start_date)
        var ed=formatDate3(searchData.end_date)
  
        var ratingdata=getratingdata(searchData.rating)
  
        // var data = {
        //   'XML': '<?xml version="1.0" encoding="UTF-8"?>\n<HotelFindRequest>\n   <Authentication>\n      <AgentCode>CD32468</AgentCode>\n      <UserName>RezliveJetoTest</UserName>\n      <Password>JetoRez@123</Password>\n   </Authentication>\n   <Booking>\n      <ArrivalDate>'+sd+'</ArrivalDate>\n      <DepartureDate>'+ed+'</DepartureDate>\n      <CountryCode>'+searchData.destcode+'</CountryCode>\n      <City>'+searchData.citycode+'</City>\n      <GuestNationality>'+nation+'</GuestNationality>\n      <HotelRatings>\n'+     ratingdata+          '</HotelRatings>\n      <Rooms>\n'+room+'</Rooms>\n   </Booking>\n</HotelFindRequest>'
        // };
        // var data = {
        //   'XML': '<?xml version="1.0" encoding="UTF-8"?>\n<HotelFindRequest>\n   <Authentication>\n      <AgentCode>CD102014</AgentCode>\n      <UserName>JVXML</UserName>\n      <Password>Operations@2024</Password>\n   </Authentication>\n   <Booking>\n      <ArrivalDate>'+sd+'</ArrivalDate>\n      <DepartureDate>'+ed+'</DepartureDate>\n      <CountryCode>'+searchData.destcode+'</CountryCode>\n      <City>'+searchData.citycode+'</City>\n      <GuestNationality>'+nation+'</GuestNationality>\n      <HotelRatings>\n'+     ratingdata+          '</HotelRatings>\n      <Rooms>\n'+room+'</Rooms>\n   </Booking>\n</HotelFindRequest>'
        // };
         var data = {
          'XML': '<?xml version="1.0" encoding="UTF-8"?>\n<HotelFindRequest>\n   <Authentication>\n      <AgentCode>CD112554</AgentCode>\n      <UserName>JETO</UserName>\n      <Password>Operations@2023</Password>\n   </Authentication>\n   <Booking>\n      <ArrivalDate>'+sd+'</ArrivalDate>\n      <DepartureDate>'+ed+'</DepartureDate>\n      <CountryCode>'+searchData.destcode+'</CountryCode>\n      <City>'+searchData.citycode+'</City>\n      <GuestNationality>'+nation+'</GuestNationality>\n      <HotelRatings>\n'+     ratingdata+          '</HotelRatings>\n      <Rooms>\n'+room+'</Rooms>\n   </Booking>\n</HotelFindRequest>'
        };
        console.log(data)
        const resdata=await rzsearchhotelbydest(data)
        setstatus("completed")
        //console.log((resdata.data))
  
        // var parser1 = new DOMParser();
        // var xmlDoc = parser1.parseFromString(resdata.data,"text/xml");
        // console.log(xmlDoc.getElementsByTagName("SearchSessionId"))
        /////////////////////////////////////////////////////////////////
  
         
         const options={
            ignoreAttributes: false,
            parseAttributeValue: false,
            parseNodeValue:false,
            // numParseOptions: {
            //     leadingZeros: true,
            //     skipLike: /\.[0-9]*0/
            // }
          }
        const parser = new XMLParser(options);
         const jObj = parser.parse(resdata.data);
        //    //var xml = new XMLParser().parseFromString(xmlresponse);
           setresponseData(jObj.HotelFindResponse)
            console.log(jObj)
            if("error" in jObj.HotelFindResponse && jObj.HotelFindResponse.error.includes("E-1004")){
              setstatus("error")
            }
           if("Hotels" in jObj.HotelFindResponse && "Hotel" in jObj.HotelFindResponse.Hotels){
            sethotelData(jObj.HotelFindResponse.Hotels.Hotel)
           }
        //console.log("Session:"+(jObj.HotelFindResponse.SearchSessionId).toString())
        var p1="data" in resdata?resdata.data.split("<SearchSessionId>"):[]
        //console.log(p1.length)
        var p2=p1.length>1?p1[1].split("</SearchSessionId>"):""
        setssid(p2[0])
        
        //     setsearchData({})
        //     setchildData([{}])
      } else {
        alert("Error:Did not find all parameters");
        setstatus("completed")
      }
    }
    
  };

  const getDest = async () => {
    try{
    const data = await fetchDest();
    const temp=data.data.filter(d=>"order" in d)
    setdest(temp[0].dest);
  }catch(err){
    console.log(err)
  }
  };

  const getCurr=async() => {
    const data=await fetchCurrencyData();
    setcurr(data.data)
    //console.log(data.data)

  }

  const getCities = async () => {
    const data = await fetchDest();
    //console.log(data.data);
    const citylist = data.data.map((arr) =>
      arr.dest[0] == searchData.destination ? [arr.cities] : []
    );
    const citylist2 = citylist?.filter((arr) => arr.length !== 0);
    const citylist3 = citylist2[0];

    setcities(citylist3 ? [...citylist3[0]] : []);
  };

  const displaydetails = (id) => {
    // setshow(!show);
    setshowid([...showid,id]);
  };
  const hidedetails = (id) => {
    
    if(showid.length>1){
      var temp=showid.filter(item => item !== id)
      setshowid(temp)
    }else{
      setshowid([])
    }
    
  };

  const getdetails=async(hotel)=>{
    setOpen4(true)
    var data = {
      'XML': '<?xml version="1.0" encoding="UTF-8"?>\n<HotelDetailsRequest>\n   <Authentication>\n      <AgentCode>CD112554</AgentCode>\n      <UserName>JETO</UserName>\n      <Password>Operations@2023</Password>\n   </Authentication>\n   <Hotels>\n      <HotelId>'+hotel.Id+'</HotelId>\n  </Hotels>\n</HotelDetailsRequest>'
    };
    //console.log(data)

    const resdata=await rzhoteldetails(data)
    //console.log(resdata.data)
    const parser = new XMLParser();
    const jObj = parser.parse(resdata.data);
   //    //var xml = new XMLParser().parseFromString(xmlresponse);
      sethdData(jObj.HotelDetailsResponse)
      //console.log(jObj)
} 

const bffilter=()=>{
  setonlybf(!onlybf)
  
}

const handleClose4 = () => {
  sethdData([{}])
  setOpen4(false);
};

const handleClose6 = () => {
  //sethdData([{}])
  setshowtnc(false);
};
  var fupsomeDate = new Date();

  fupsomeDate.setDate(fupsomeDate.getDate());
  const fupy = fupsomeDate.getFullYear();
  const fupm =
    fupsomeDate.getMonth() + 1 < 10
      ? "0" + (fupsomeDate.getMonth() + 1)
      : fupsomeDate.getMonth() + 1;
  const fupdt =
    fupsomeDate.getDate() < 10
      ? "0" + fupsomeDate.getDate()
      : fupsomeDate.getDate();
  const fupfinalDate2 = fupy + "-" + fupm + "-" + fupdt;

  useEffect(() => {
    getDest();
    getCurr()
  }, []);

  useEffect(() => {
    getCities();
  }, [searchData.destination]);

  useEffect(() => {
    getHotels();
  }, [searchData.city]);

  const getHotels=async()=>{
    if(searchData.destination && searchData.city){
      const data=await fetchdestHotelsbyDestandCity(searchData.destination, searchData.city);
      let sortedHotels = data.data.sort((a, b) => {
        if (a.hotel_name < b.hotel_name) {
            return -1;
        }
        if (a.hotel_name > b.hotel_name) {
            return 1;
        }
        return 0;
    });;
      
      //console.log(sortedHotels)
      setlisthotelData(sortedHotels)
    }
    
  }

  const childage = (value, name, num, id) => {
    // const tempobj = {
    //   childnum: num + 1,
    //   age: value,
    // };
    const newdata = roomdata[name];
    //setchildData([...newdata.childnumber, tempobj]);
    newdata.childnumber[num]=value
    //console.log(newdata)
    // const newitem = { ...newdata, childnumber: [...newdata.childnumber, tempobj]};
    // console.log(newitem)
    setroomdata(roomdata.map((item) => (item.id == id ? newdata : item)));
  };

  const destidentify = (e) => {
    var x = destcode(e.target.value);
    //console.log(x)
    setsearchData({ ...searchData, destination: e.target.value, destcode: x });
  };

  const cityidentify = (e) => {
    var x = citycode(e.target.value);
    //console.log(x)
    setsearchData({ ...searchData, city: e.target.value, citycode: x });
  };

  const filterresults = () => {
    var newData = responseData.Hotels.Hotel;
    console.log(newData)
    if (filterData.rating && filterData.text && filterData.text !== "") {
      //console.log("ABC")
      newData = newData.filter(
        (hotel) =>
          hotel.Rating == filterData.rating &&
          hotel.Name.toLowerCase().includes(filterData.text.toLowerCase())
      );
    } else if (filterData.text && filterData.text !== "") {
      //console.log("DEF")
      newData = newData.filter((hotel) =>
        hotel.Name.toLowerCase().includes(filterData.text.toLowerCase())
      );
    } else if (filterData.rating) {
      if(Array.isArray(newData)){//console.log("GHI")
      newData = newData.filter((hotel) => hotel.Rating == filterData.rating);
      }
    }
    //console.log(filterData)
    //console.log(newData)
    ;
    if("mealplan" in filterData && hotelData && filterData.mealplan != ""){
      var hd2=[]
      var rd2=[]
      if(Array.isArray(newData)){
      for(let i=0;i<newData.length;i++){
        if(Array.isArray(newData[i].RoomDetails.RoomDetail)){
          if(filterData.mealplan=="Only Breakfast"){
            rd2=newData[i].RoomDetails.RoomDetail.filter(rd=> "RoomDescription" in rd && rd.RoomDescription.includes("Breakfast") && !rd.RoomDescription.includes("Dinner") && !rd.RoomDescription.includes("Lunch"))
          }else if(filterData.mealplan=="Half Board"){
            rd2=newData[i].RoomDetails.RoomDetail.filter(rd=> "RoomDescription" in rd && (rd.RoomDescription.includes("Breakfast") && rd.RoomDescription.includes("Dinner")) || rd.RoomDescription.includes("Half Board"))
          }else if(filterData.mealplan=="Full Board"){
            rd2=newData[i].RoomDetails.RoomDetail.filter(rd=> "RoomDescription" in rd && (rd.RoomDescription.includes("Breakfast") && rd.RoomDescription.includes("Dinner") && rd.RoomDescription.includes("Lunch")) || rd.RoomDescription.includes("Full Board"))
          }else if(filterData.mealplan=="All Inclusive"){
            rd2=newData[i].RoomDetails.RoomDetail.filter(rd=> "RoomDescription" in rd && rd.RoomDescription.includes("All Inclusive") )
          }else if(filterData.mealplan=="Room Only"){
            rd2=newData[i].RoomDetails.RoomDetail.filter(rd=> "RoomDescription" in rd && rd.RoomDescription.includes("Room Only") )
          }
          
          const temproomdetails={...newData[i].RoomDetails, RoomDetail:rd2}
          const temphotel={...newData[i], RoomDetails:temproomdetails}
          if(temphotel.RoomDetails.RoomDetail.length>0){
            hd2=[...hd2,temphotel]
          }
        }else{
          if(filterData.mealplan=="Only Breakfast"){
            rd2="RoomDescription" in newData[i].RoomDetails.RoomDetail && newData[i].RoomDetails.RoomDetail.RoomDescription.includes("Breakfast") && !newData[i].RoomDetails.RoomDetail.RoomDescription.includes("Dinner") && !newData[i].RoomDetails.RoomDetail.RoomDescription.includes("Lunch")?newData[i].RoomDetails.RoomDetail:[]
          }else if(filterData.mealplan=="Half Board"){
            rd2="RoomDescription" in newData[i].RoomDetails.RoomDetail && (newData[i].RoomDetails.RoomDetail.RoomDescription.includes("Breakfast") && newData[i].RoomDetails.RoomDetail.RoomDescription.includes("Dinner")) || newData[i].RoomDetails.RoomDetail.RoomDescription.includes("Half Board")?newData[i].RoomDetails.RoomDetail:[]
          }else if(filterData.mealplan=="Full Board"){
            rd2="RoomDescription" in newData[i].RoomDetails.RoomDetail && (newData[i].RoomDetails.RoomDetail.RoomDescription.includes("Breakfast") && newData[i].RoomDetails.RoomDetail.RoomDescription.includes("Dinner") && newData[i].RoomDetails.RoomDetail.RoomDescription.includes("Lunch")) || newData[i].RoomDetails.RoomDetail.RoomDescription.includes("Full Board")?newData[i].RoomDetails.RoomDetail:[]
          }else if(filterData.mealplan=="All Inclusive"){
            rd2="RoomDescription" in newData[i].RoomDetails.RoomDetail && newData[i].RoomDetails.RoomDetail.RoomDescription.includes("All Inclusive") ?newData[i].RoomDetails.RoomDetail:[]
          }else if(filterData.mealplan=="Room Only"){
            rd2="RoomDescription" in newData[i].RoomDetails.RoomDetail && newData[i].RoomDetails.RoomDetail.RoomDescription.includes("Room Only")?newData[i].RoomDetails.RoomDetail:[]
          }
         
          const temproomdetails={...newData[i].RoomDetails, RoomDetail:rd2}
          const temphotel={...newData[i], RoomDetails:temproomdetails}
          if(temphotel.RoomDetails.RoomDetail.length>0){
            hd2=[...hd2,temphotel]
          }
        }
      }
      newData=hd2
    }else{
      
        if(Array.isArray(newData.RoomDetails.RoomDetail)){
          if(filterData.mealplan=="Only Breakfast"){
            rd2=newData.RoomDetails.RoomDetail.filter(rd=> "RoomDescription" in rd && rd.RoomDescription.includes("Breakfast") && !rd.RoomDescription.includes("Dinner") && !rd.RoomDescription.includes("Lunch"))
          }else if(filterData.mealplan=="Half Board"){
            rd2=newData.RoomDetails.RoomDetail.filter(rd=> "RoomDescription" in rd && (rd.RoomDescription.includes("Breakfast") && rd.RoomDescription.includes("Dinner")) || rd.RoomDescription.includes("Half Board"))
          }else if(filterData.mealplan=="Full Board"){
            rd2=newData.RoomDetails.RoomDetail.filter(rd=> "RoomDescription" in rd && (rd.RoomDescription.includes("Breakfast") && rd.RoomDescription.includes("Dinner") && rd.RoomDescription.includes("Lunch")) || rd.RoomDescription.includes("Full Board"))
          }else if(filterData.mealplan=="All Inclusive"){
            rd2=newData.RoomDetails.RoomDetail.filter(rd=> "RoomDescription" in rd && rd.RoomDescription.includes("All Inclusive") )
          }else if(filterData.mealplan=="Room Only"){
            rd2=newData.RoomDetails.RoomDetail.filter(rd=> "RoomDescription" in rd && rd.RoomDescription.includes("Room Only") )
          }
          
          const temproomdetails={...newData.RoomDetails, RoomDetail:rd2}
          const temphotel={...newData, RoomDetails:temproomdetails}
          if(temphotel.RoomDetails.RoomDetail.length>0){
            hd2=[...hd2,temphotel]
          }
        }else{
          if(filterData.mealplan=="Only Breakfast"){
            rd2="RoomDescription" in newData.RoomDetails.RoomDetail && newData.RoomDetails.RoomDetail.RoomDescription.includes("Breakfast") && !newData.RoomDetails.RoomDetail.RoomDescription.includes("Dinner") && !newData.RoomDetails.RoomDetail.RoomDescription.includes("Lunch")?newData.RoomDetails.RoomDetail:[]
          }else if(filterData.mealplan=="Half Board"){
            rd2="RoomDescription" in newData.RoomDetails.RoomDetail && (newData.RoomDetails.RoomDetail.RoomDescription.includes("Breakfast") && newData.RoomDetails.RoomDetail.RoomDescription.includes("Dinner")) || newData.RoomDetails.RoomDetail.RoomDescription.includes("Half Board")?newData.RoomDetails.RoomDetail:[]
          }else if(filterData.mealplan=="Full Board"){
            rd2="RoomDescription" in newData.RoomDetails.RoomDetail && (newData.RoomDetails.RoomDetail.RoomDescription.includes("Breakfast") && newData.RoomDetails.RoomDetail.RoomDescription.includes("Dinner") && newData.RoomDetails.RoomDetail.RoomDescription.includes("Lunch")) || newData.RoomDetails.RoomDetail.RoomDescription.includes("Full Board")?newData.RoomDetails.RoomDetail:[]
          }else if(filterData.mealplan=="All Inclusive"){
            rd2="RoomDescription" in newData.RoomDetails.RoomDetail && newData.RoomDetails.RoomDetail.RoomDescription.includes("All Inclusive") ?newData.RoomDetails.RoomDetail:[]
          }else if(filterData.mealplan=="Room Only"){
            rd2="RoomDescription" in newData.RoomDetails.RoomDetail && newData.RoomDetails.RoomDetail.RoomDescription.includes("Room Only")?newData.RoomDetails.RoomDetail:[]
          }
         
          const temproomdetails={...newData.RoomDetails, RoomDetail:rd2}
          const temphotel={...newData, RoomDetails:temproomdetails}
          if(temphotel.RoomDetails.RoomDetail.length>0){
            hd2=[...hd2,temphotel]
          }
        
      }
      newData=hd2
    }
      
    }

    //console.log(newData)
    if("price" in filterData && hotelData && filterData.price != ""){
      console.log("ABC")
      var hd3=[]
      var rd3=[]
      for(let i=0;i<newData.length;i++){
        console.log(i)
        if(Array.isArray(newData[i].RoomDetails.RoomDetail)){
          if(filterData.price=="Less than 2k"){
            rd3=newData[i].RoomDetails.RoomDetail.filter(rd=> "TotalRate" in rd && calccost(rd.TotalRate)<=2000)
          }else if(filterData.price=="2k to 4k"){
            rd3=newData[i].RoomDetails.RoomDetail.filter(rd=> "TotalRate" in rd && calccost(rd.TotalRate)>2000 && calccost(rd.TotalRate)<=4000)
          }else if(filterData.price=="4k to 6k"){
            rd3=newData[i].RoomDetails.RoomDetail.filter(rd=> "TotalRate" in rd && calccost(rd.TotalRate)>4000 && calccost(rd.TotalRate)<=6000)
          }else if(filterData.price=="6k to 8k"){
            rd3=newData[i].RoomDetails.RoomDetail.filter(rd=> "TotalRate" in rd && calccost(rd.TotalRate)>6000 && calccost(rd.TotalRate)<=8000)
          }else if(filterData.price=="8k to 10k"){
            rd3=newData[i].RoomDetails.RoomDetail.filter(rd=> "TotalRate" in rd && calccost(rd.TotalRate)>8000 && calccost(rd.TotalRate)<=10000 )
          }else if(filterData.price=="10k to 12k"){
            rd3=newData[i].RoomDetails.RoomDetail.filter(rd=> "TotalRate" in rd && calccost(rd.TotalRate)>10000 && calccost(rd.TotalRate)<=12000 )
          }else if(filterData.price=="12k to 15k"){
            rd3=newData[i].RoomDetails.RoomDetail.filter(rd=> "TotalRate" in rd && calccost(rd.TotalRate)>12000 && calccost(rd.TotalRate)<=15000 )
          }else if(filterData.price=="More than 15k"){
            rd3=newData[i].RoomDetails.RoomDetail.filter(rd=> "TotalRate" in rd && calccost(rd.TotalRate)>15000 )
          }
          console.log(rd3)
          const temproomdetails={...newData[i].RoomDetails, RoomDetail:rd3}
          const temphotel={...newData[i], RoomDetails:temproomdetails}
          if(temphotel.RoomDetails.RoomDetail.length>0){

            hd3=[...hd3,temphotel]
          }
        }else{
          console.log("DEF")
          if(filterData.price=="Less than 2k"){
            rd3="TotalRate" in newData[i].RoomDetails.RoomDetail && calccost(newData[i].RoomDetails.RoomDetail.TotalRate)<=2000?newData[i].RoomDetails.RoomDetail:[]
          }else if(filterData.price=="2k to 4k"){
            rd3="TotalRate" in newData[i].RoomDetails.RoomDetail && calccost(newData[i].RoomDetails.RoomDetail.TotalRate)>2000 && calccost(newData[i].RoomDetails.RoomDetail.TotalRate)<=4000?newData[i].RoomDetails.RoomDetail:[]
          }else if(filterData.price=="4k to 6k"){
            rd3="TotalRate" in newData[i].RoomDetails.RoomDetail && calccost(newData[i].RoomDetails.RoomDetail.TotalRate)>4000 && calccost(newData[i].RoomDetails.RoomDetail.TotalRate)<=6000?newData[i].RoomDetails.RoomDetail:[]
          }else if(filterData.price=="6k to 8k"){
            rd3="TotalRate" in newData[i].RoomDetails.RoomDetail && calccost(newData[i].RoomDetails.RoomDetail.TotalRate)>6000 && calccost(newData[i].RoomDetails.RoomDetail.TotalRate)<=8000?newData[i].RoomDetails.RoomDetail:[]
          }else if(filterData.price=="8k to 10k"){
            rd3="TotalRate" in newData[i].RoomDetails.RoomDetail && calccost(newData[i].RoomDetails.RoomDetail.TotalRate)>8000 && calccost(newData[i].RoomDetails.RoomDetail.TotalRate)<=10000?newData[i].RoomDetails.RoomDetail:[]
          }else if(filterData.price=="10k to 12k"){
            rd3="TotalRate" in newData[i].RoomDetails.RoomDetail && calccost(newData[i].RoomDetails.RoomDetail.TotalRate)>10000 && calccost(newData[i].RoomDetails.RoomDetail.TotalRate)<=12000?newData[i].RoomDetails.RoomDetail:[]
          }else if(filterData.price=="12k to 15k"){
              rd3="TotalRate" in newData[i].RoomDetails.RoomDetail && calccost(newData[i].RoomDetails.RoomDetail.TotalRate)>12000 && calccost(newData[i].RoomDetails.RoomDetail.TotalRate)<=15000?newData[i].RoomDetails.RoomDetail:[]
            }else if(filterData.price=="More than 15k"){
            rd3="TotalRate" in newData[i].RoomDetails.RoomDetail && calccost(newData[i].RoomDetails.RoomDetail.TotalRate)>15000?newData[i].RoomDetails.RoomDetail:[]
          }
          console.log(rd3)
          const temproomdetails={...newData[i].RoomDetails, RoomDetail:rd3}
          const temphotel={...newData[i], RoomDetails:temproomdetails}
          if(temphotel.RoomDetails.RoomDetail.length>0){
            hd3=[...hd3,temphotel]
          }
        }
      }
      sethotelData(hd3)
      //console.log(hd3)
    }else{
      sethotelData(newData)
      console.log(newData)
    }
  };

  const addsp = () => {
    //console.log(spdata)

    setroomdata(
      roomdata.length == 0 ? [{ id: uuidv4(), childnumber:[] }] : [...roomdata, { id: uuidv4(), childnumber:[] }]
    );
  };

  const removesp = () => {
    //console.log(spdata)
    setroomdata([...roomdata].slice(0, roomdata.length - 1));
  };

  const adultschange = (e, tid, id) => {
    //console.log(tid, id)
    const newdata = roomdata[tid];
    //console.log(newdata)
    const newitem = { ...newdata, number_adults: e.target.value };
    //console.log(newitem)
    setroomdata(roomdata.map((item) => (item.id == id ? newitem : item)));
    //setdata([...data, data[tid]=newitem])
    // console.log(cpdata)
  };

  const childchange = (e, tid, id) => {
    //console.log(tid, id)
    const newdata = roomdata[tid];
    const temp=newdata.childnumber
    const arr=childagearray(e.target.value)
    for(let i=0; i<arr.length; i++){
      arr[i]=temp[i]?temp[i]:0
    }
    const newitem = { ...newdata, number_child: e.target.value, childnumber:arr };
    //console.log(newitem)
    setroomdata(roomdata.map((item) => (item.id == id ? newitem : item)));
    //setdata([...data, data[tid]=newitem])
    // console.log(cpdata)
  };

  const calccost=(str)=>{
    //console.log(str)
    if(str.toString().includes("|")){
      //console.log(curr[0].usd_inr)
      const temp=str.split("|")
      temp.map(s => s.trim());
      var numberArray = temp.map(Number)
      const sum = numberArray.reduce((partialSum, a) => partialSum + a, 0);
      // console.log(Math.round(sum*curr[0].usd_inr))
      return Math.round(sum*curr[0].usd_inr)
      //return Math.round(sum)
    }else{
      //console.log("Here")
      //console.log(curr[0].usd_inr)
      // console.log(Math.round(parseInt(str)*curr[0].usd_inr))
      // return Math.round(parseInt(str)*curr[0].usd_inr)
      return Math.round(str*curr[0].usd_inr)
    }
    

  }

  const showbookingpage=(e, rd, hotel)=>{
    setshowbook(true)
    setroomdetails(rd)
    sethoteldetails(hotel)
  }

  const showbooktnc=(e, rd, hotel)=>{
    setshowtnc(true)
    //const temp="Description:\n"+rd.RoomDescription.replaceAll("|","\n")+"\n\nTnc:\n"+rd.TermsAndConditions
    //const temp=rd.RoomDescription+rd.TermsAndConditions
    console.log(rd)
    settnc(rd)
  }

  const handleChange=()=>{
    setsearchbyid(!searchbyid)
  }

  return (
    <div>
    {showbook?(
      <div>
      <Button
                    variant="contained"
                    color="primary"
                    onClick={e=>setshowbook(false)}
                    
                    className={classes.button}
                  >
                    Back
                  </Button>
      <RezliveBook 
        responseData={responseData}
        roomdetails={roomdetails}
        hoteldetails={hoteldetails}
        searchData={searchData}
        ssid={ssid}
      />
      </div>
      ):(
        <div>
      <Paper id="myDIV" variant="outlined" className={classes.paper}>
      <div >
      <FormControlLabel control={<Switch  onChange={handleChange} color="secondary" label="Search by Hotel"/>}/>
      <div align="right">
      <Button
              variant="outlined"
              color="secondary"
              className={classes.button3}
              href={"/hotelview"}
              
            >
              {" "}
              View Booked Hotels
            </Button>
      </div>
      
      </div>
        <form onSubmit={handleSubmit}>
          <FormGroup row className={classes.formgroup}>
            <FormControl
              style={{
                minWidth: 200,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="destination">Destination</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="destination"
                variant="outlined"
                required
                value={searchData.destination}
                onChange={(e) => destidentify(e)}
              >
                {dest.map((dest) => {
                  return <MenuItem value={dest}>{dest}</MenuItem>;
                })}
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 200,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="city">City</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="city"
                variant="outlined"
                required
                value={searchData.city}
                onChange={(e) => cityidentify(e)}
              >
                {cities.map((city) => {
                  return <MenuItem value={city}>{city}</MenuItem>;
                })}
              </Select>
            </FormControl>
            <TextField
              variant="outlined"
              type="date"
              inputProps={{ min: fupfinalDate2 }}
              label="Start Date"
              required
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData({ ...searchData, start_date: e.target.value })
              }
            />
            <TextField
              variant="outlined"
              type="date"
              label="End Date"
              required
              inputProps={{ min: "start_date" in searchData && searchData.start_date?searchData.start_date:fupfinalDate2 }}
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData({ ...searchData, end_date: e.target.value })
              }
            />
            {searchbyid?(
              <FormControl
              style={{
                minWidth: 200,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="hotel">Hotel</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="hotel"
                variant="outlined"
                required
                value={searchData.hotel}
                onChange={(e) => setsearchData({ ...searchData, hotel: e.target.value })}
              >
              {listhotelData.map(h=>
                <MenuItem value={h.hotel_name}>{h.hotel_name}</MenuItem>
              )}
                 
              </Select>
            </FormControl>
            ):(
            <FormControl
              style={{
                minWidth: 200,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="rating2">Rating</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="rating2"
                variant="outlined"
                required
                value={searchData.rating}
                onChange={(e) => setsearchData({ ...searchData, rating: e.target.value })}
              >
                 <MenuItem value={1}>1</MenuItem>
                 <MenuItem value={2}>2</MenuItem>
                 <MenuItem value={3}>3</MenuItem>
                 <MenuItem value={4}>4</MenuItem>
                 <MenuItem value={5}>5</MenuItem>
                 <MenuItem value={23}>23</MenuItem>
                 <MenuItem value={34}>34</MenuItem>
                 <MenuItem value={45}>45</MenuItem>
                 <MenuItem value={234}>234</MenuItem>
                 <MenuItem value={345}>345</MenuItem>
                 <MenuItem value={12345}>12345</MenuItem>
                 
              </Select>
            </FormControl>
            
            )}
            {/* <FormControl
              style={{
                minWidth: 200,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="nationality">Nationality</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="nationality"
                variant="outlined"
                required
                value={searchData.nationality}
                onChange={(e) => setsearchData({ ...searchData, nationality: e.target.value })}
              >
              {destlist.map(dest=>
                <MenuItem value={dest}>{dest}</MenuItem>
              )}
                 
                 
              </Select>
            </FormControl> */}
          </FormGroup>
          {roomdata.map(room => {
            return(
            <div>
            <FormGroup row className={classes.formgroup}>
            <Typography className={classes.textField}>{"Room "+(roomdata.indexOf(room)+1)}</Typography>
            
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Adults"># Adults (number)</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="Adults"
                required
                name={roomdata.indexOf(room)}
                variant="outlined"
                value={room.number_adults}
                onChange={(e) => adultschange(e, e.target.name, room.id)}
              >
                <MenuItem value={1}>1 </MenuItem>
                <MenuItem value={2}>2 </MenuItem>
                <MenuItem value={3}>3 </MenuItem>
                <MenuItem value={4}>4 </MenuItem>
                <MenuItem value={5}>5 </MenuItem>
                <MenuItem value={6}>6 </MenuItem>
                <MenuItem value={7}>7 </MenuItem>
                <MenuItem value={8}>8 </MenuItem>
                <MenuItem value={9}>9 </MenuItem>
              </Select>
            </FormControl>
            <FormControl
              style={{
                minWidth: 160,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="Child"># Child (number)</InputLabel>
              <Select
                displayEmpty
                classname={classes.textField}
                labelId="Child"
                name={roomdata.indexOf(room)}
                variant="outlined"
                value={room.number_child}
                onChange={(e) => childchange(e, e.target.name, room.id)}
              >
                <MenuItem value={0}>0 </MenuItem>
                <MenuItem value={1}>1 </MenuItem>
                <MenuItem value={2}>2 </MenuItem>
                <MenuItem value={3}>3 </MenuItem>
                <MenuItem value={4}>4 </MenuItem>
                <MenuItem value={5}>5 </MenuItem>
                <MenuItem value={6}>6 </MenuItem>
              </Select>
            </FormControl>
          </FormGroup>
          <FormGroup row className={classes.formgroup}>
            {room.childnumber.map((child) => (
              <FormControl
                style={{
                  minWidth: 100,
                  marginTop: 16,
                  marginRight: 32,
                  marginLeft: 32,
                }}
              >
                <InputLabel>
                  Age of child {room.childnumber.indexOf(child) + 1}
                </InputLabel>
                <Select
                  displayEmpty
                  required
                  classname={classes.textField}
                  variant="outlined"
                  name={roomdata.indexOf(room)}
                  value={child.age}
                  onChange={(e) =>
                    childage(e.target.value, e.target.name, room.childnumber.indexOf(child), room.id)
                  }
                >
                  <MenuItem value={2}>2 </MenuItem>
                  <MenuItem value={3}>3 </MenuItem>
                  <MenuItem value={4}>4 </MenuItem>
                  <MenuItem value={5}>5 </MenuItem>
                  <MenuItem value={6}>6 </MenuItem>
                  <MenuItem value={7}>7 </MenuItem>
                  <MenuItem value={8}>8 </MenuItem>
                  <MenuItem value={9}>9 </MenuItem>
                  <MenuItem value={10}>10 </MenuItem>
                  <MenuItem value={11}>11 </MenuItem>
                  <MenuItem value={12}>12 </MenuItem>
                </Select>
              </FormControl>
            ))}
          </FormGroup>
            <hr></hr>
            </div>)
          })}
          
          <br></br>
          <FormGroup row className={classes.formgroup}>
          <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={addsp}
            >
              {" "}
              + Room
            </Button>
            
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={removesp}
              
            >
              {" "}
              - Room
            </Button>
           
            <Button
              variant="contained"
              color="primary"
              type="submit"
              className={classes.button}
            >
              Search
            </Button>
          </FormGroup>
        </form>
      </Paper>
      {status === "Normal" ? (
        ""
      ) : (
        <div>
          {status == "searching" ? (
            <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
          ) : (
            <div>
            {status == "error" ?(<div>
              <h2>IP Address Error {responseData.error}</h2>
            </div>):(
              <div>
              <Paper variant="outlined" className={classes.paper}>
                <FormGroup row className={classes.formgroup}>
                <FormControl
                    style={{
                      minwidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 32,
                    }}
                  >
                    <InputLabel id="mealplan">Meal Plan</InputLabel>
                    <Select
                      displayEmpty
                      classname={classes.textField}
                      labelId="mealplan"
                      variant="outlined"
                      value={filterData.mealplan}
                      onChange={(e) =>
                        setfilterData({ ...filterData, mealplan: e.target.value })
                      }
                      // onChange={e=>ratingchange(e)}
                    >
                      <MenuItem value="">Clear</MenuItem>
                      <MenuItem value={"Only Breakfast"}>Only Breakfast</MenuItem>
                      <MenuItem value={"Half Board"}>Half Board</MenuItem>
                      <MenuItem value={"Full Board"}>Full Board</MenuItem>
                      <MenuItem value={"All Inclusive"}>All Inclusive</MenuItem>
                      <MenuItem value={"Room Only"}>Room Only</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl
                    style={{
                      minwidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 32,
                    }}
                  >
                    <InputLabel id="price">Price</InputLabel>
                    <Select
                      displayEmpty
                      classname={classes.textField}
                      labelId="price"
                      variant="outlined"
                      value={filterData.price}
                      onChange={(e) =>
                        setfilterData({ ...filterData, price: e.target.value })
                      }
                      // onChange={e=>ratingchange(e)}
                    >
                      <MenuItem value="">Clear</MenuItem>
                      <MenuItem value={"Less than 2k"}>Less than 2k</MenuItem>
                      <MenuItem value={"2k to 4k"}>2k to 4k</MenuItem>
                      <MenuItem value={"4k to 6k"}>4k to 6k</MenuItem>
                      <MenuItem value={"6k to 8k"}>6k to 8k</MenuItem>
                      <MenuItem value={"8k to 10k"}>8k to 10k</MenuItem>
                      <MenuItem value={"10k to 12k"}>10k to 12k</MenuItem>
                      <MenuItem value={"12k to 15k"}>12k to 15k</MenuItem>
                      <MenuItem value={"More than 15k"}>More than 15k</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl
                    style={{
                      minwidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 32,
                    }}
                  >
                    <InputLabel id="rating">Rating</InputLabel>
                    <Select
                      displayEmpty
                      classname={classes.textField}
                      labelId="rating"
                      variant="outlined"
                      value={filterData.rating}
                      onChange={(e) =>
                        setfilterData({ ...filterData, rating: e.target.value })
                      }
                      // onChange={e=>ratingchange(e)}
                    >
                      <MenuItem value="">Clear</MenuItem>
                      <MenuItem value={1}>1</MenuItem>
                      <MenuItem value={2}>2</MenuItem>
                      <MenuItem value={3}>3</MenuItem>
                      <MenuItem value={4}>4</MenuItem>
                      <MenuItem value={5}>5</MenuItem>
                    </Select>
                  </FormControl>

                  <TextField
                    variant="outlined"
                    label="Name"
                    value={filterData.text}
                    className={classes.textField}
                    onChange={(e) =>
                      setfilterData({ ...filterData, text: e.target.value })
                    }
                    // onChange={e=>textchange(e)}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={filterresults}
                    
                    className={classes.button}
                  >
                    Filter
                  </Button>
                </FormGroup>

                {hotelData.length > 0 ? (
                  <div>
                    <hr></hr>
                    <FormGroup row className={classes.formgroup}>
                      <Typography variant="h6">
                        {" "}
                        Arrival Date: {responseData.ArrivalDate} || Departure
                        Date: {responseData.DepartureDate} || Currency:{" "}
                        {responseData.Currency} || Nationality:{" "}
                        {responseData.GuestNationality}
                      </Typography>
                    </FormGroup>
                    <Typography
                      variant="h4"
                      align="center"
                      className={classes.headertext}
                    >
                      {" "}
                      Hotel List (Count:{hotelData.length})
                    </Typography>
                    {hotelData.map((hotel) => (
                      <div>
                        <Table>
                          <TableHead>
                            <TableCell>
                              <Typography>
                                {" "}
                                {hotelData.indexOf(hotel) + 1}. {hotel.Name} (
                                {hotel.Rating})
                              </Typography>
                            </TableCell>
                            <TableCell align="right">
                              {showid.includes(hotelData.indexOf(hotel))? (
                                <div>
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  onClick={(e) =>
                                    getdetails(hotelData[hotelData.indexOf(hotel)])
                                  }
                                  className={classes.button2}
                                >
                                  Details
                                </Button>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={(e) =>
                                    hidedetails(hotelData.indexOf(hotel))
                                  }
                                  className={classes.button2}
                                >
                                  Hide
                                </Button>
                                </div>
                              ) : (
                                <div>
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  onClick={(e) =>
                                    getdetails(hotelData[hotelData.indexOf(hotel)])
                                  }
                                  className={classes.button2}
                                >
                                  Details
                                </Button>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={(e) =>
                                    displaydetails(hotelData.indexOf(hotel))
                                  }
                                  className={classes.button2}
                                >
                                  Show
                                </Button>
                                </div>
                                
                              )}
                            </TableCell>
                          </TableHead>

                          {showid.includes(hotelData.indexOf(hotel)) ? (
                            <div>
                            {Array.isArray(hotel.RoomDetails.RoomDetail)?(
                              <div>
                              {hotel.RoomDetails.RoomDetail.map((rd) => (
                                <div>
                                  <TableRow>
                                    <TableCell width={width / 2}>
                                      {"Type" in rd && rd.Type.includes("|")?(rd.Type.split("|").map(t=><p>{t}</p>)):rd.Type}
                                    </TableCell>
                                    <TableCell width={width / 8}>
                                    {String(rd.TotalRate).includes("|")?"INR "+calccost(rd.TotalRate):"INR "+Math.round(rd.TotalRate*curr[0].usd_inr)}
                                    </TableCell>
                                    <TableCell width={width / 12}>
                                      {"BoardBasis" in rd && rd.BoardBasis.includes("|")?rd.BoardBasis.replaceAll("|","\n"):rd.BoardBasis}
                                    </TableCell>
                                    <TableCell width={width / 6}>
                                      {"RoomDescription" in rd && rd.RoomDescription.includes("|")?rd.RoomDescription.replaceAll("|","\n"):rd.RoomDescription}
                                    </TableCell>
                                    <TableCell width={width / 8}>
                                      {"CancellationPolicy" in rd && "Refundable" in rd.CancellationPolicy && rd.CancellationPolicy.Refundable == "Yes"
                                        ? "Refundable"
                                        : ""}
                                      {"CancellationPolicy" in rd && "TillDate" in rd.CancellationPolicy
                                        ? " till "+rd.CancellationPolicy.TillDate
                                        : ""}
                                    </TableCell>
                                    {/* <TableCell width={width/10}>
        {rd.ChildrenAges.map(cp=>
<div>
  {cp.name} {cp.value}
</div>
        )}
        </TableCell> */}
                                    <TableCell width={width / 8}>
                                      A:{rd.Adults} C:{rd.Children}
                                    </TableCell>
                                    <TableCell width={width / 12}>
                                    {/* <Link to={{pathname:"/hotelbook",state:{hotels:hotelData,hotel:hotel,rd:rd},}} target="_blank"> */}
                                    {/* <Link to={{pathname:"/hotelbook",state:{data:"ABC"}}}> */}
                                    {role=="Admin" || role=="TL"?( <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={e=>showbookingpage(e, rd, hotel)}
                                        className={classes.button2}
                                      >
                                        PreBook
                                      </Button>):("")}
                                     
                                      <Button
                                        variant="contained"
                                        color="inherit"
                                        onClick={e=>showbooktnc(e, rd, hotel)}
                                        className={classes.button2}
                                      >
                                        TnC
                                      </Button>
                                      {/* </Link> */}
                                    </TableCell>
                                  </TableRow>
                                </div>
                              ))}
                              </div>
                            ):(
                              <div>
                              <TableRow>
                                    <TableCell width={width / 2}>
                                      {hotel.RoomDetails.RoomDetail.Type.includes("|")?hotel.RoomDetails.RoomDetail.Type.replaceAll("|","&"):hotel.RoomDetails.RoomDetail.Type}
                                    </TableCell>
                                    <TableCell width={width / 8}>
                                    {String(hotel.RoomDetails.RoomDetail.TotalRate).includes("|")?calccost(hotel.RoomDetails.RoomDetail.TotalRate):Math.round(hotel.RoomDetails.RoomDetail.TotalRate)}
                                    </TableCell>
                                    <TableCell width={width / 12}>
                                      {"BoardBasis" in hotel.RoomDetails.RoomDetail && hotel.RoomDetails.RoomDetail.BoardBasis.includes("|")?hotel.RoomDetails.RoomDetail.BoardBasis.replaceAll("|","\n"):hotel.RoomDetails.RoomDetail.BoardBasis}
                                    </TableCell>
                                    <TableCell width={width / 6}>
                                      {"RoomDescription" in hotel.RoomDetails.RoomDetail && hotel.RoomDetails.RoomDetail.RoomDescription.includes("|")?hotel.RoomDetails.RoomDetail.RoomDescription.replaceAll("|","\n"):hotel.RoomDetails.RoomDetail.RoomDescription}
                                    </TableCell>
                                    <TableCell width={width / 8}>
                                      {"CancellationPolicy" in hotel.RoomDetails.RoomDetail && hotel.RoomDetails.RoomDetail.CancellationPolicy.Refundable == "Yes"
                                        ? "Refundable"
                                        : ""}
                                      {"CancellationPolicy" in hotel.RoomDetails.RoomDetail && "TillDate" in hotel.RoomDetails.RoomDetail.CancellationPolicy
                                        ? " till "+hotel.RoomDetails.RoomDetail.CancellationPolicy.TillDate
                                        : ""}
                                    </TableCell>
                                    {/* <TableCell width={width/10}>
        {hotel.RoomDetails.RoomDetail.ChildrenAges.map(cp=>
<div>
  {cp.name} {cp.value}
</div>
        )}
        </TableCell> */}
                                    <TableCell width={width / 8}>
                                      A:{hotel.RoomDetails.RoomDetail.Adults} C:{hotel.RoomDetails.RoomDetail.Children}
                                    </TableCell>
                                    <TableCell width={width / 12}>
                                    {/* <Link to={{pathname:"/hotelbook",state:{hotels:hotelData,hotel:hotel,hotel.RoomDetails.RoomDetail:hotel.RoomDetails.RoomDetail},}} target="_blank"> */}
                                    {/* <Link to={{pathname:"/hotelbook",state:{data:"ABC"}}}> */}
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={e=>showbookingpage(e, hotel.RoomDetails.RoomDetail, hotel)}
                                        className={classes.button2}
                                      >
                                        Book
                                      </Button>
                                      {/* </Link> */}
                                    </TableCell>
                                  </TableRow>
                              </div>
                            )}
                              
                            </div>
                          ) : (
                            ""
                          )}
                        </Table>
                        <hr></hr>
                      </div>
                    ))}
                  </div>
                ) : (
                  "No results found"
                )}
              </Paper>
            </div>
            )}
           </div>
          )}
        </div>
      )}
      </div>)}
      <Dialog fullWidth maxWidth="m" open={Open4} onClose={handleClose4}>
        {hdData?(
          <div>
            {hdData.Hotels?(
              <div>
                <h2 className={classes.headertext}>Name: {hdData.Hotels.HotelName}</h2>
                <h2 className={classes.headertext}>Location: {hdData.Hotels.City}, {hdData.Hotels.Country} </h2>
                <h2 className={classes.headertext}>Address: {hdData.Hotels.HotelAddress}</h2>
                <h2 className={classes.headertext}>Contact: {hdData.Hotels.Phone} </h2>
                <h2 className={classes.headertext}>Description:</h2>
                <h4 className={classes.headertext}>{hdData.Hotels.Description}</h4>
                <h2 className={classes.headertext}>Hotel Amenities:</h2>
                <h4 className={classes.headertext}>{hdData.Hotels.HotelAmenities}</h4>
                <h2 className={classes.headertext}>Room Amenities:</h2>
                <h4 className={classes.headertext}>{hdData.Hotels.RoomAmenities}</h4>
              </div>
            ):("Hotel Details not found")}
          </div>
        ):(
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
        )}
      </Dialog>
      <Dialog fullWidth maxWidth="m" open={showtnc} onClose={handleClose6}>
        {tnc?(
          <div>
          <p><b>Room Description</b></p>
            {tnc.RoomDescription.includes("|")?(tnc.RoomDescription.split("|").map(t=>
            <div>
            <p>{t}</p>
            </div>
            )):(tnc.RoomDescription)}
            <p><b>Terms And Conditions</b></p>
            {tnc.TermsAndConditions.includes("|")?(tnc.TermsAndCondition.split("|").map(c=>
            <div>
            <p>{c}</p>
            </div>
            )):(tnc.TermsAndConditions)}
          </div>
        ):(
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
        )}
      </Dialog>
    </div>
  );
};

export default RezliveSearch;
